import { useEffect, useRef } from 'react';
import { useAppSelector } from '../../store/hooks';

export function GlobalShortcuts() {
  const overlays = useAppSelector((state) => state.overlays.stack);
  const overlaysRef = useRef(overlays);
  const keys = useRef(new Map<string, number>());

  useEffect(() => {
    overlaysRef.current = overlays;
  }, [overlays]);

  useEffect(() => {
    const listener = (event: KeyboardEvent) => {
      const key = event.key.toLowerCase();
      const now = Date.now();
      const previous = keys.current.get(key) ?? 0;
      keys.current.set(key, now);
      if (now - previous > 400) return;
      const target = event.target;
      const typing =
        target instanceof HTMLInputElement ||
        target instanceof HTMLTextAreaElement ||
        target instanceof HTMLSelectElement ||
        (target instanceof HTMLElement && target.isContentEditable);
      if (key === 'q') {
        const top = overlaysRef.current.at(-1);
        if (top?.closable) {
          window.dispatchEvent(new CustomEvent('dnd-close-overlay', { detail: { id: top.id } }));
        }
      } else if (key === ' ' && !typing) {
        window.dispatchEvent(new CustomEvent('dnd-save-active'));
      }
    };
    window.addEventListener('keydown', listener);
    return () => window.removeEventListener('keydown', listener);
  }, []);
  return null;
}
